var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "05-legal-changes",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.3,37.1l-4.6-18c1.2-0.2,2.3-0.4,3.4-0.8L59,14.1c-2,0.6-4.1,0.9-6.2,0.9c-6.2,0-14.1-2.6-18.2-7.1V4H30v3.9 c-4.1,4.5-12,7.1-18.2,7.1c-2.1,0-4.2-0.3-6.2-0.9l-1.3,4.4c1.1,0.3,2.2,0.5,3.3,0.7L2.6,38.2c-0.3,0.7-0.5,1.6-0.5,2.4 c0,5.2,4.2,9.4,9.4,9.4s9.4-4.2,9.4-9.4c0-0.9-0.2-1.8-0.6-2.6l-4.8-18.8c5.3-0.8,12.2-3.1,16.1-6.7h1c3.7,3.4,10.4,5.7,15.4,6.6 l-4.6,18c-0.3,0.8-0.5,1.6-0.5,2.5c0,5.2,4.2,9.4,9.4,9.4s9.4-4.2,9.4-9.4C61.9,38.8,61.7,37.9,61.3,37.1z M11.6,21.3l3.2,13.1 H8.4L11.6,21.3z M11.6,45.5c-2.7,0-4.9-2.2-4.9-4.9c0-0.9,0.7-1.6,1.6-1.6h6.5c0.9,0,1.6,0.7,1.6,1.6 C16.5,43.3,14.3,45.5,11.6,45.5z M55.6,33.5h-6.3l3.2-13.1L55.6,33.5z M52.4,44.5c-2.7,0-4.9-2.2-4.9-4.9c0-0.9,0.7-1.6,1.6-1.6 h6.5c0.9,0,1.6,0.7,1.6,1.6C57.3,42.3,55.1,44.5,52.4,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1,58.3c-0.2-0.5-0.6-1-1-1.5c-0.4-0.4-0.9-0.8-1.5-1c-0.5-0.2-1.1-0.3-1.7-0.3l-12.5,0l0-31.4c0-0.6-0.1-1.2-0.3-1.7 c-0.2-0.5-0.6-1-1-1.5c-0.4-0.4-0.9-0.8-1.5-1c-0.5-0.2-1.1-0.3-1.7-0.3l0,35.9c0,0,0,0,0,0H12.8V60h21.5c0,0,0.1,0,0.1,0l0,0 l17.1,0C51.4,59.4,51.3,58.8,51.1,58.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.056fe507cfaa348404c1c2ced62a083f.svg";
export { ForwardRef as ReactComponent };